module.exports = __webpack_public_path__ + "media/silence.4af2bbe1.mp3";